// main storage for our WPShopify features.
window.WPShopify = window.WPShopify || {};
window.WPShopify.ajax_url = window.WPShopify.ajax_url || window.ajaxurl || (window.MILX && window.MILX.ajaxurl )|| 'https://miniluxe.staging.wpengine.com/wp-admin/admin-ajax.php';
window.WPShopify.shop_url = window.WPShopify.shop_url || (window.MILX &&  window.MILX.shop_url )|| 'https://miniluxe-development.myshopify.com';
window.WPShopify.Shop = window.WPShopify.Shop || {};

// contains all functions\class methods which will be used to init dynamic blocks
window.WPShopify.blocksInits = window.WPShopify.blocksInits || {};

// contains all dynamic and static blocks initialized via js
window.WPShopify.blockInstances = window.WPShopify.blockInstances || {};
